import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";


import { environment } from "./environments/environment";
import { AppComponent } from "./app/app.component";
import { ServiceWorkerModule } from "@angular/service-worker";
import { NgIdleModule } from "@ng-idle/core";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatExpansionModule } from "@angular/material/expansion";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { MyMissingTranslationHandler } from "./app/shared/missing-translation";
import { TranslationLoaderService } from "src/app/services/translation.service";
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from "@ngx-translate/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { AgGridModule } from "ag-grid-angular";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { AngularDraggableModule } from "angular2-draggable";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { MatNativeDateModule } from "@angular/material/core";
import { MMMAdminModule } from "src/app/admin-mmm/admin-mmm.module";
import { SystemReportsModule } from "./app/systemreports/system.reports.module";
import { ToastrModule } from "ngx-toastr";
import { withInterceptorsFromDi, provideHttpClient, HttpClient } from "@angular/common/http";
import { MatButtonModule } from "@angular/material/button";
import { MatTableModule } from "@angular/material/table";
import { MatSelectModule } from "@angular/material/select";
import { appRoutingModule } from "./app/app.routing";
import { SharedModule } from "./app/shared/shared.module";
import { MatIconModule } from "@angular/material/icon";
import { SelectModule } from "./app/shared/select.module";
import { MatFormFieldModule } from "@angular/material/form-field";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgChartsModule } from "ng2-charts";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CrewmanagementModule } from "./app/crewmanagement/crewmanagement.module";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatRadioModule } from "@angular/material/radio";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatTabsModule } from "@angular/material/tabs";
import { MatBadgeModule } from "@angular/material/badge";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { environment as environment_1 } from "src/environments/environment.base";
import { SystemReportsStyle } from "./app/systemreports/system.reports.style";
import { ImageCompressService, ResizeOptions } from "@artiomsu/ng2-image-compress";
import { DatePipe, APP_BASE_HREF } from "@angular/common";
import { QueryBuilderConstants } from "./app/query-builder/query-builder-constants";
import { QueryBuilderService } from "src/app/services/query-builder.service";
import { TranslateService } from "./app/services/translate.service";
import { AssetAttributesService } from "./app/services/asset-attributes.service";
import { AuthenticationService } from "./app/services/authentication.service";
import { AuthGuard } from "./app/helpers/auth.gaurd";

if (environment.production) {
  enableProdMode();
}

if (environment.production) {
  enableProdMode();

  if (window) {
    // tslint:disable-next-line:only-arrow-functions
    // window.console.log = function() {};
  }
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        appRoutingModule,
        importProvidersFrom(MatButtonToggleModule, MatBadgeModule, MatTabsModule, MatCheckboxModule, MatRadioModule, MatAutocompleteModule, CrewmanagementModule, BrowserAnimationsModule, NgChartsModule, NgbModule, FormsModule, MatFormFieldModule, SelectModule.forRoot(), MatIconModule, SharedModule, 
        MatSelectModule, MatTableModule, MatButtonModule, ReactiveFormsModule, ToastrModule.forRoot(), SystemReportsModule.forRoot(), MMMAdminModule.forRoot(), MatNativeDateModule, MatInputModule, MatDatepickerModule, AngularDraggableModule, DragDropModule, AgGridModule, 
        // ng2ImageViewerModule,
        // Added by Abhilash Jira Id:-40 on 9/28/2021
        NgSelectModule, TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: TranslationLoaderService,
                deps: [HttpClient]
            },
            isolate: true,
            missingTranslationHandler: { provide: MissingTranslationHandler, useClass: MyMissingTranslationHandler }
        }), FontAwesomeModule, MatExpansionModule, MatPaginatorModule, MatMenuModule, NgIdleModule.forRoot(), ServiceWorkerModule.register('sw.js?v=1', { scope: './' })),
        AuthenticationService, AssetAttributesService, TranslateService, QueryBuilderService, QueryBuilderConstants, DatePipe, ImageCompressService, ResizeOptions, SystemReportsStyle, { provide: APP_BASE_HREF, useValue: environment.baseHref },
        provideHttpClient(withInterceptorsFromDi())
    ]
})
  .catch((err) => console.error(err));
